var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeSavings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "011---Auto-Save",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46 46v-39.172c-.0001133-.53038963-.2109013-1.03901454-.586-1.414l-4.828-4.828c-.3749855-.37509875-.8836104-.58588673-1.414-.586h-35.172c-2.209139 0-4 1.790861-4 4v38c0 2.209139 1.790861 4 4 4z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m35 46h-30v-24c.0032948-1.1032019.89679813-1.9967052 2-2h32c1.1032019.0032948 1.9967052.8967981 2 2v10.64z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5 6c-.26519481-.00005664-.51950727-.10545063-.707-.293l-.293-.293-.293.293c-.39237889.37897221-1.01608478.37355237-1.40181858-.01218142-.38573379-.3857338-.39115363-1.00943969-.01218142-1.40181858l1-1c.39049985-.39038194 1.02350015-.39038194 1.414 0l1 1c.28590792.28599425.37142191.71603662.21667798 1.08965456s-.51928208.61725909-.92367798.61734544z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m38 0v14c-.0032948 1.1032019-.8967981 1.9967052-2 2h-22c-1.1032019-.0032948-1.9967052-.8967981-2-2v-14z",
    fill: "#bdc3c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m14 16h-4c-1.10320187-.0032948-1.9967052-.8967981-2-2v-14h4v14c.0032948 1.1032019.8967981 1.9967052 2 2z",
    fill: "#285680"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m33 13c-.5522847 0-1-.4477153-1-1v-8c0-.55228475.4477153-1 1-1s1 .44771525 1 1v8c0 .5522847-.4477153 1-1 1z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a5a5a4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m36 26h-26c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h26c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 31h-22c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h22c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27 36h-17c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h17c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m25 41h-15c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h15c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 44,
    cy: 44,
    fill: "#d1d4d1",
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m48 49c-.2651948-.0000566-.5195073-.1054506-.707-.293l-4-4c-.1875494-.1874927-.2929434-.4418052-.293-.707v-8c0-.5522847.4477153-1 1-1s1 .4477153 1 1v7.586l3.707 3.707c.2859079.2859943.3714219.7160366.216678 1.0896546-.1547439.3736179-.5192821.6172591-.923678.6173454z",
    fill: "#3b97d3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSavings);
export default __webpack_public_path__ + "static/media/time-savings.70f39c532091449a9cb3f8d7a84b10d4.svg";
export { ForwardRef as ReactComponent };